import styled from 'styled-components';

export const Toolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-end;
  margin-bottom: 16px;
`;

export const TableCard = styled.div`
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(21, 43, 78, 0.08);
  overflow: hidden;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;

  th,
  td {
    padding: 12px 14px;
    text-align: left;
    border-bottom: 1px solid #eef2f7;
    vertical-align: middle;
  }

  th {
    background: #f8fafc;
    color: #64748b;
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    font-weight: 700;
  }

  tr:last-child td {
    border-bottom: none;
  }

  @media (max-width: 900px) {
    display: block;
    overflow-x: auto;
  }
`;

export const StatusPill = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: ${(props) => (props.$ok ? '#166534' : '#991b1b')};
  background: ${(props) => (props.$ok ? '#dcfce7' : '#fee2e2')};
`;

export const EventBadgeList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  max-width: 280px;
`;

export const EventBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  color: #1e3a5f;
  background: #e8eef5;
`;

export const RowActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const GhostButton = styled.button`
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #152b4e;
  border-radius: 8px;
  min-height: 34px;
  padding: 0.35rem 0.8rem;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  cursor: pointer;

  &:hover {
    background: #f8fafc;
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

export const DangerButton = styled(GhostButton)`
  color: #b91c1c;
  border-color: #fecaca;

  &:hover {
    background: #fef2f2;
  }
`;

export const EmptyState = styled.div`
  padding: 36px 20px;
  text-align: center;
  color: #64748b;
`;

export const FormGrid = styled.div`
  display: grid;
  gap: 12px;
  padding: 8px 4px 4px;
`;

export const FieldBlock = styled.label`
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 0.8rem;
  font-weight: 600;
  color: #475569;
  letter-spacing: 0.02em;
`;

export const TextInput = styled.input`
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  min-height: 40px;
  padding: 0.5rem 0.75rem;
  font-size: 0.9rem;
  color: #152b4e;

  &:focus {
    outline: none;
    border-color: #152b4e;
    box-shadow: 0 0 0 3px rgba(21, 43, 78, 0.12);
  }
`;

export const TextSelect = styled.select`
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  min-height: 40px;
  padding: 0.5rem 0.75rem;
  font-size: 0.9rem;
  color: #152b4e;
  background: #fff;

  &:focus {
    outline: none;
    border-color: #152b4e;
    box-shadow: 0 0 0 3px rgba(21, 43, 78, 0.12);
  }
`;

export const Hint = styled.span`
  font-size: 0.75rem;
  font-weight: 500;
  color: #94a3b8;
`;

export const ModalBodyPad = styled.div`
  padding: 4px 8px 12px;
  max-height: ${(props) => (props.$tall ? '80vh' : '70vh')};
  overflow: auto;
`;

export const EventsMeta = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  color: #64748b;
  font-size: 0.85rem;
`;

export const DetailGrid = styled.div`
  display: grid;
  gap: 10px;
`;

export const DetailRow = styled.div`
  display: grid;
  grid-template-columns: 160px 1fr;
  gap: 8px;
  font-size: 0.88rem;

  strong {
    color: #64748b;
    font-weight: 600;
  }

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`;

export const JsonBlock = styled.pre`
  margin: 0;
  padding: 12px;
  background: #0f172a;
  color: #e2e8f0;
  border-radius: 8px;
  font-size: 0.75rem;
  line-height: 1.45;
  overflow: auto;
  max-height: ${(props) => (props.$tall ? '380px' : '280px')};
  white-space: pre-wrap;
  word-break: break-word;
`;

export const ClickableRow = styled.tr`
  cursor: pointer;

  &:hover td {
    background: #f8fafc;
  }
`;
